import React from 'react';
import Dashboard from '../components/dashboard/dashboard';

export default function DashboardPage() {
    return (
        <>
            <Dashboard/>
        </>
    )
}